<template>
  <div :style="divStyle">
    <div class="d-flex align-center">
      <v-checkbox v-model="allSelect" :true-value="'Y'" :false-value="'N'" @change="allSelectChange($event)" />
      <span>전체 선택</span>
    </div>
    <v-expansion-panels v-model="expandedPanel" accordion>
      <v-expansion-panel v-for="(row, i) in datasource" :key="i">
        <v-expansion-panel-header
          :ref="`expansionPanelHeader_${i}`"
          v-bind:color="titleColorList[i] ? titleColorList[i].color : ''"
          @click="titleClick(i)"
        >
          <div class="d-flex align-center">
            <v-row no-gutters align="center">
              <v-col v-if="!readonly" cols="1">
                <div class="ma-1 d-flex justify-center align-center">
                  <!-- Main Titile -->
                  <v-btn v-if="row.__created__" small text icon @click="removeProcess(i)">
                    <svg-icon icon-class="delete-red" style="height: 22px !important" />
                  </v-btn>
                  <v-checkbox v-else v-model="row.useYn" :true-value="'Y'" :false-value="'N'" @change="headerCheck(row, $event)" @click.stop />
                </div>
              </v-col>
              <!-- Main Titile -->
              <v-col cols="7">
                <v-text-field v-if="row.__created__ && !row.readonly" :style="mainStyle" v-model="row.processNm" solo class="editor_bg" />
                <span v-else :style="mainStyle">{{ row.processNm }}</span>
              </v-col>
              <v-col cols="4" align="center" v-if="!readonly && !fileMode">
                <span :style="mainStyle">(적용:{{ row.applyCnt ? row.applyCnt : 0 }} / 작업내용:{{ row.totalCnt ? row.totalCnt : 0 }})</span>
                <v-tooltip right color="primary" max-width="300px">
                  <template v-slot:activator="{ on }">
                    <span>
                      <svg-icon icon-class="info" style="height: 1rem" v-on="on" />
                    </span>
                  </template>
                  <div class="tooltip-text">{{ '해당 항목은 저장 후 갱신됩니다.' }}</div>
                </v-tooltip>
              </v-col>
            </v-row>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <template v-if="fileMode">
            <span v-if="row.__created__">
              <h4>공정정보를 먼저 저장 후 파일을 등록해주세요.</h4>
            </span>
            <iFileManage
              v-else
              class="mt-5"
              :ref="`iFileUploader_${row.clntId}_${row.compId}_${row.writeDt}_${row.docNo}_${row.constructId}_${row.processId}`"
              :targetId="`${row.clntId}_${row.compId}_${row.writeDt}_${row.docNo}_${row.constructId}_${row.processId}`"
              targetType="00026"
              :titleDesc="'파일 등록 시 바로 저장됩니다.'"
              fileExtension=".pdf"
              :readOnly="readonly"
              :maxFileCount="1"
              @onFileChanged="onFileChanged($event, row)"
            />
          </template>
          <template v-else>
            <!-- 작업공정 안전보건정보 작성 -->
            <v-row v-for="(workRow, index) in row.works" :key="index" no-gutters class="px-0 pb-0">
              <v-col cols="12" class="pa-0 d-flex align-center">
                <div v-if="!readonly" class="ma-1 d-flex justify-center align-center">
                  <v-btn v-if="workRow.__created__" small text icon @click="removeWork(i, index)">
                    <svg-icon icon-class="delete-red" style="height: 20px !important" />
                  </v-btn>
                  <v-checkbox v-else v-model="workRow.useYn" :true-value="'Y'" :false-value="'N'" @change="contentCheck(workRow, $event, row)" />
                </div>
                <v-text-field v-if="!workRow.__created__ || workRow.readonly" v-model="workRow.workNm" solo class="editor_bg" readonly />
                <v-text-field v-else v-model="workRow.workNm" solo class="editor_bg" />
              </v-col>
            </v-row>
            <div v-if="!readonly" class="d-flex justify-center align-center pa-0 mt-3">
              <v-btn elevation="0" @click="addData('work', i)" width="100%" height="48" class="table-add-btn">
                <svg-icon icon-class="table-add" width="20" height="20" />
              </v-btn>
            </div>
          </template>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <div v-if="!readonly" class="w-full d-flex justify-center align-center">
        <v-btn elevation="0" @click="addData('process')" width="100%" height="48" class="table-add-btn">
          <svg-icon icon-class="table-add" width="20" height="20" />
        </v-btn>
      </div>
    </v-expansion-panels>
    <i-dxpopup
      :popupVisible="popupVisible"
      :title="title"
      @popupCloseButtonClick="popupClose"
      height="336px"
      width="500px"
      max-height="336px"
      max-width="500px"
    >
      <template v-slot:content>
        <v-row no-gutters class="template-btn-wrap">
          <v-col cols="12" md="6">
            <v-card @click="btnTemplate(type)" class="template-btn">
              <svg-icon icon-class="template" style="height: 60px" />
              <div class="btn-title">
                목록에서 추가
                <!-- <v-tooltip top color="primary" max-width="240px">
                  <template v-slot:activator="{ on }">
                    <svg-icon icon-class="info" style="height: 1rem" v-on="on" />
                  </template>
                  <div class="tooltip-text">
                    • 
                  </div>
                </v-tooltip>-->
              </div>
              <div class="btn-desc">소중안에서 제공해드리는 자료로 {{ type == 'process' ? '공정' : '작업내용' }}을 추가합니다.</div>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card @click="type == 'process' ? addProcess() : addWork(processIndex)" class="template-btn">
              <svg-icon icon-class="template" style="height: 60px" />
              <div class="btn-title">직접 입력하기</div>
              <div class="btn-desc">
                소중안의 시스템을 활용하는 대신,
                <br />
                사용자가 직접 {{ type == 'process' ? '공정' : '작업내용' }}을 입력합니다.
              </div>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </i-dxpopup>
    <process-popup
      v-if="!readonly"
      :key="processComponentKey"
      :popupVisible="processPopupVisible"
      :selected="datasource"
      title="공정 관리"
      :mode="processMode"
      @apply="processApply"
      @popupClose="popupClose('process')"
    />
    <work-popup
      v-if="!readonly"
      :key="workComponentKey"
      :popupVisible="workPopupVisible"
      :selected="process"
      title="작업내용 관리"
      :mode="workMode"
      @apply="workApply"
      @popupClose="popupClose('work')"
    />
  </div>
</template>

<script>
import notify from 'devextreme/ui/notify'
import iDxPopup from '@/components/common/iDxPopup.vue'
import processPopup from './processPopup.vue'
import workPopup from './workPopup.vue'
import iFileManage from '@/components/esgCommon/iFileManage.vue'

export default {
  components: {
    'i-dxpopup': iDxPopup,
    'process-popup': processPopup,
    'work-popup': workPopup,
    iFileManage,
  },
  name: 'expansionPanelTreeProcess',
  props: {
    fileMode: {
      type: Boolean,
      default: false,
    },
    assessmentKey: {
      type: String,
      default: '',
    },
    datasource: {
      type: Array,
      default: () => [],
    },
    headerDefaultColor: {
      type: String,
      default: '#fff',
    },
    headerExpandedColor: {
      type: String,
      default: '#fff',
    },
    mainStyle: {
      type: String,
      default: 'font-size: 1rem; font-weight: 600',
    },
    sub1Style: {
      type: String,
      default: 'font-size: 1rem; font-weight: 400;',
    },
    sub2Style: {
      type: String,
      default: 'font-size: 1rem; font-weight: 400',
    },
    textStyle: {
      type: String,
      default: 'font-size: medium;',
    },
    divStyle: {
      type: String,
      default: '',
    },
    firstDataExpand: {
      type: Boolean,
      default: false,
    },
    searchProcess: {
      type: String,
      default: '',
    },
    changedFlag: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expandedPanel: [],
      titleColorList: [],
      popupVisible: false,
      processPopupVisible: false,
      workPopupVisible: false,
      title: '',
      type: '',
      processIndex: null,
      processMode: 'single',
      workMode: 'single',
      process: {},
      processComponentKey: 'proc0', // 고유한 키 값
      workComponentKey: 'work0', // 고유한 키 값
      allSelect: 'N',
    }
  },
  watch: {
    datasource() {
      this.titleColorList = []
      this.datasource.forEach((row) => {
        let defaultColor = {
          color: this.headerDefaultColor,
        }
        this.titleColorList.push(defaultColor)
      })
      if (this.searchProcess && !this.changedFlag) {
        let index = this.datasource.findIndex((element) => element.processId == this.searchProcess)
        this.expandedPanel = index
        if (this.titleColorList[index]) {
          this.titleColorList[index].color = this.headerExpandedColor
        } else {
          this.titleColorList[index] = { color: this.headerExpandedColor }
        }
      } else {
        this.expandedPanel = []
      }
    },
  },
  mounted() {
    this.datasource.forEach((row, i) => {
      let defaultColor = {
        color: i == 0 && this.firstDataExpand ? this.headerExpandedColor : this.headerDefaultColor,
      }
      this.titleColorList.push(defaultColor)
    })

    if (this.firstDataExpand) {
      this.expandedPanel = [0]
    }
  },
  methods: {
    forceRerender(type) {
      if (type == 'process') {
        this.processComponentKey = 'proc' + (parseInt(this.processComponentKey.replace('proc', '')) + 1)
      } else if (type === 'work') {
        this.workComponentKey = 'work' + (parseInt(this.workComponentKey.replace('work', '')) + 1)
      }
    },
    titleClick(index) {
      if (this.titleColorList[index].color === this.headerDefaultColor) {
        this.titleColorList[index].color = this.headerExpandedColor
        this.titleColorList.forEach((element) => {
          if (element != this.titleColorList[index]) element.color = this.headerDefaultColor
        })
        this.$emit('titleClick', this.datasource[index])
      } else {
        this.titleColorList[index].color = this.headerDefaultColor
        this.$emit('titleClick', {})
      }
      this.process = this.datasource[index]
      // if (typeof this.expandedPanel !== 'number') {
      // 패널이 열리는 경우에만 파일 조회
      setTimeout(() => {
        //
        this.$nextTick(() => {
          if (this.fileMode) {
            const ref =
              this.$refs[
                `iFileUploader_${this.process.clntId}_${this.process.compId}_${this.process.writeDt}_${this.process.docNo}_${this.process.constructId}_${this.process.processId}`
              ]
            if (ref) {
              ref[0].btnSearch()
            }
          }
        })
      }, 200)
      // }
    },
    addData(type, index) {
      if (!this.assessmentKey) {
        notify(this.$t('위험성평가를 선택해주세요.'), 'warning', 1000)
        return
      }
      this.popupVisible = true
      this.type = type
      this.title = type == 'process' ? '공정 추가' : '작업내용 추가'
      if (type == 'work') this.processIndex = index
    },
    //추가버튼
    addWork(index) {
      this.popupClose()
      if (!this.assessmentKey) {
        notify(this.$t('위험성평가를 선택해주세요.'), 'warning', 1000)
        return
      }
      const [clntId, compId, writeDt, docNo] = this.assessmentKey.split('_')

      const row = {
        clntId: clntId,
        compId: compId,
        writeDt: writeDt,
        docNo: docNo,
        workNm: '',
        useYn: 'Y',
        __created__: true,
      }

      this.datasource[index].works.push(row)
      this.datasource[index].__updated__ = true
    },
    addProcess() {
      this.popupClose()
      if (!this.assessmentKey) {
        notify(this.$t('위험성평가를 선택해주세요.'), 'warning', 1000)
        return
      }
      const [clntId, compId, writeDt, docNo] = this.assessmentKey.split('_')

      const row = {
        clntId: clntId,
        compId: compId,
        writeDt: writeDt,
        docNo: docNo,
        processNm: '',
        works: [],
        useYn: 'Y',
        __created__: true,
      }

      this.datasource.push(row)
    },
    //삭제버튼
    removeWork(header, index) {
      this.datasource[header].works.splice(index, 1)
    },
    removeProcess(index) {
      this.datasource.splice(index, 1)
    },

    allSelectChange(event) {
      this.datasource.forEach((row) => {
        row.useYn = event
        row.__updated__ = true
        this.headerCheck(row, event)
      })
    },
    headerCheck(row, event) {
      this.$nextTick(() => {
        row.works.forEach((workRows) => {
          workRows.useYn = event
          workRows.__updated__ = true
        })
      })
      row.useYn = event
      row.__updated__ = true
    },
    contentCheck(row, event, headRow) {
      this.$nextTick(() => {
        if (event == 'Y') {
          headRow.useYn = event
        }
      })
      row.useYn = event
      headRow.__updated__ = true
      row.__updated__ = true
    },
    processApply(selected) {
      const [clntId, compId, writeDt, docNo] = this.assessmentKey.split('_')
      selected.forEach((element) => {
        if (!element.writeDt) {
          element.clntId = clntId
          element.compId = compId
          element.writeDt = writeDt
          element.docNo = docNo
          element.__created__ = true
          element.readonly = true
        }
        element.works.forEach((work) => {
          if (!work.writeDt) {
            work.clntId = clntId
            work.compId = compId
            work.writeDt = writeDt
            work.docNo = docNo
            work.__created__ = true
            work.readonly = true
          }
        })
      })
      this.$emit('apply', selected)
      this.popupClose('process')
    },
    workApply(selected) {
      const [clntId, compId, writeDt, docNo] = this.assessmentKey.split('_')
      const data = this.datasource[this.processIndex]
      selected.forEach((element) => {
        if (!element.writeDt) {
          element.clntId = clntId
          element.compId = compId
          element.writeDt = writeDt
          element.docNo = docNo
          element.constructId = data.constructId
          element.processId = data.processId
          element.__created__ = true
          element.readonly = true
        }
      })
      this.datasource[this.processIndex].works = selected
      this.$emit('apply', this.datasource)
      this.popupClose('work')
    },
    btnTemplate(type) {
      this.forceRerender(type)
      if (type == 'process') this.processPopupVisible = true
      if (type == 'work') this.workPopupVisible = true
      this.popupClose()
    },
    popupClose(type) {
      if (!type) this.popupVisible = false
      if (type == 'process') this.processPopupVisible = false
      if (type == 'work') this.workPopupVisible = false
    },
    async onFileChanged(fileList, row) {
      row.fileList = fileList
      const ref = this.$refs[`iFileUploader_${row.clntId}_${row.compId}_${row.writeDt}_${row.docNo}_${row.constructId}_${row.processId}`]
      if (ref) {
        const savePromise = await ref[0].btnSave(row.fileList)
        if (savePromise) {
          row.fileList = {
            insert: [],
            delete: [],
          }

          ref[0].btnSearch()
        }
      }
    },
    btnFileSearch() {
      this.datasource.forEach((row) => {
        if (this.fileMode) {
          const ref = this.$refs[`iFileUploader_${row.clntId}_${row.compId}_${row.writeDt}_${row.docNo}_${row.constructId}_${row.processId}`]
          console.log('@@@@ btnFileSearch', ref)
          if (ref && ref[0]) {
            ref[0].btnSearch()
          }
        }
      })
    },
    collapseAllPanel() {
      this.expandedPanel = []
    },
  },
}
</script>
<style lang="scss">
@import '@/assets/theme/variables.scss';
.template-btn-wrap {
  padding: 0 24px;
  gap: 12px;
  flex-wrap: nowrap;
  .col-md-6,
  .col-12 {
    flex: unset !important;
  }
}
.template-btn {
  border-radius: 8px;
  border: 2px solid $card_border;
  background: $white;
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  word-break: keep-all;

  .btn-title {
    font-size: 1rem;
    font-weight: 600;
    line-height: normal;
    padding: 8px 0 24px;
  }
  .btn-desc {
    color: #808080;
    text-align: center;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: normal;
  }
  &:hover {
    border: 2px solid $primary;
    box-shadow: 0px 4px 8px 0px rgba(27, 83, 243, 0.15);
    .btn-title {
      font-size: 1rem;
      font-weight: 600;
      line-height: normal;
      color: $primary;
    }
  }
}
.tooltip-text {
  word-break: keep-all;
}
</style>
